module.exports = __webpack_public_path__ + "img/easy8_icon_yellow.e91630eb.svg";